import styled from "styled-components";

export const StyledBlockchainUrlWrapper = styled.div`
  .blockchain-url-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    &__create {
      display: inline-grid;
      justify-content: end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      &__create {
        justify-content: start;
      }
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }

  .blockchain-url {
    &__head, &__row {
      grid-template-columns: 150px 0.75fr minmax(250px, 1.5fr) 240px;
    }
    &__actions {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      grid-gap: 25px;
    }
  }
`;